import { combineReducers, createStore, applyMiddleware } from 'redux'
// import { createLogger } from 'redux-logger'
import thunkMiddleware from 'redux-thunk'

import { systemReducer } from './system/reducer';
import { notificationsReducer } from './notifications/reducer';

export const rootReducer = combineReducers({
    system: systemReducer,
    notifications: notificationsReducer
});
  
export type RootState = ReturnType<typeof rootReducer>;

// const loggerMiddleware = createLogger()

export const store = createStore(
  rootReducer,
  applyMiddleware(
    thunkMiddleware,
    // loggerMiddleware,
  )
)

export default store
export * from './connectors'
